import * as Yup from 'yup';
import { CHANGE_MILEAGE_USAGE_ERRORS } from '@acorn-portal/shared/src/utils/constants/ErrorMessages';
import { isUsedForBusiness } from '@acorn-portal/shared/src/utils';

export const changeOfUsageOrMileageSchema = () =>
	Yup.object({
		vehicleUse: Yup.string().required(CHANGE_MILEAGE_USAGE_ERRORS.vehicleUse),
		levelOfCover: Yup.string().required(CHANGE_MILEAGE_USAGE_ERRORS.levelOfCover),
		annualMileage: Yup.string().required(CHANGE_MILEAGE_USAGE_ERRORS.annualMileage),
		businessMileage: Yup.string().when('vehicleUse', {
			is: (vehicleUse: string) => isUsedForBusiness(vehicleUse),
			then: (schema) => schema.required(CHANGE_MILEAGE_USAGE_ERRORS.businessMileage),
			otherwise: (schema) => schema.optional(),
		}),
	});
